import { FC } from 'react';

// third-party
import { useSnackbar, WithSnackbarProps, OptionsObject } from 'notistack';

// ==============================|| CUSTOM FUNCTION - NOTISTACK ||============================== //

interface IProps {
  setUseSnackbarRef: (showSnackbar: WithSnackbarProps) => void;
}

const InnerSnackbarUtilsConfigurator: FC<IProps> = (props: IProps) => {
  props.setUseSnackbarRef(useSnackbar());
  return null;
};

let useSnackbarRef: WithSnackbarProps;
const setUseSnackbarRef = (useSnackbarRefProp: WithSnackbarProps) => {
  useSnackbarRef = useSnackbarRefProp;
};

export const SnackbarUtilsConfigurator = () => {
  return <InnerSnackbarUtilsConfigurator setUseSnackbarRef={setUseSnackbarRef} />;
};

export default function toast(msg: string, options: OptionsObject = {}) {
  useSnackbarRef.enqueueSnackbar(msg, options);
}
